const projectData = [
  {
    id: 1,
    name: "Forum - LinkedIn (clone)",
    src: `./images/projectPreviews/forum.png`,
    description:
      "A full stack forum app based on a social media platform allows users to participate in discussions, share information, and connect with like-minded individuals in a community-driven environment. User can perform all actions like seraching, posting, commenting, liking, sharing etc.",
    techStack:
      "Tech Stack : React.js | Typescript | Redux | Chakra UI | Node | Express",
    detail: "A Collaborative project, built in 5 days by 3 member",
    sourceCode: "https://github.com/AshokPrjapati/Forum_App",
    liveLink: "https://forum-app-6dad7.web.app/",
  },
  {
    id: 2,
    name: "Capsule- Tata 1mg (clone)",
    src: "./images/projectPreviews/capsule.png",
    description:
      "Capsule (Tata 1mg) provides services, including e-pharmacy, diagnostics, e-consultation and health content. You can buy your allopathic, ayurvedic, homeopathic medicines, vitamins & nutrition supplements and other health-related.",
    techStack:
      "Tech Stack : React.js | Chakra UI | HTML5 | CSS3 | Javascript | JSON Server",
    detail: "A Solo project, built in 6 days.",
    sourceCode: "https://github.com/AshokPrjapati/Capsule-1mg_clone",
    liveLink: "https://capsule-six.vercel.app",
  },
  {
    id: 3,
    name: "MiddleMan- Buffer (clone)",
    src: `./images/projectPreviews/middle-man.png`,
    description:
      "Buffer provides services, including social-media management, content publishing and make online presence. Provides multiple packages for yearly, monthly ads weekly basis. Make Social Media handling easy and saves a lot a time.",
    techStack: "Tech Stack : HTML5 | CSS3 | Javascript | Mock API Server",
    detail: "A Collaborative project, built in 6 days by 4 member",
    sourceCode: "https://github.com/AshokPrjapati/MiddleMan_Buffer-Clone",
    liveLink: "https://cozy-banoffee-f5b339.netlify.app/",
  },
  {
    id: 4,
    name: "Apni Dukan - meesho (clone)",
    src: `./images/projectPreviews/apni_dukan.png`,
    description:
      "Apni Dukan is an e-commarce website which provides products realted to clothing, beauty and home care. Here user can view the products, see the detail of product, can add to cart and buy product. This project also include admin panel where admin can see all the data of products and user and also can make change",
    techStack:
      "Tech Stack : Next.js | Redux | Chakra-UI | JavaScript | Json-Server",
    detail: "A Collaborative project, built in 5 days by 5 member",
    sourceCode: "https://github.com/AshokPrjapati/Meesho-clone",
    liveLink: "https://meesho-clone-ashokprjapati.vercel.app",
  },
  {
    id: 5,
    name: "Urban(clone)",
    src: `./images/projectPreviews/urban.png`,
    description:
      "Urban Comapny provides variess servics like salon, painting, cleaning etc.This project is static website where objective is to implement the basic knowledge of HTML,CSS and Javascript.",
    techStack: "Tech Stack : HTML5 | CSS3 | Javascript",
    detail: "A Solo project, built in 5 days.",
    sourceCode: "https://github.com/AshokPrjapati/Urban-Company",
    liveLink: "https://mellifluous-sprinkles-3ec6e3.netlify.app",
  },
];

export default projectData;
